/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';

import styles from '../../../../ActionDrawer.module.scss';
import Loading from '../../../../../../components/Loading/Loading';
import ElectroCheckList from '../../../../../../forms/components/inputs/ElectroCheckList/ElectroCheckList';

type TypeProps = {|
  locations: Array,
  form: TypeForm,
|} & TranslatorProps;

@translate()
@inject('locationStore')
@observer
export default class ArchiveLocationByCompanyForm extends React.Component<*> {
  getAddress(location: Object): string {
    const addressItems = ['address_1', 'address_2', 'address_3'];
    const address = [];

    for (let locationItem in location.address) {
      if (addressItems.includes(locationItem)) {
        address.push(location.address[locationItem]);
      }
    }

    return address.join(', ');
  }

  render(): React.Node {
    const { t, locationStore, companyId, form }: TypeProps = this.props;
    const endpoint = `companies/${companyId}/locations`;

    if (locationStore.locations.active.length === 0) {
      return <Loading />;
    }

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ElectroCheckList
            field={form.$('selectLocation.locations')}
            heading={t('general:actions.archive_company_locations')}
            enableSearch={true}
            endpoint={endpoint}
            searchKeys={['company_name', 'country_name', 'site_name']}
            primaryLiteral={(item: Object) =>
              `${item.company_name} - ${item.country_name} - ${item.site_name}`
            }
            secondaryLiteral={(location: Object) => (
              <React.Fragment>
                <b>{this.getAddress(location)}</b>
                <div>
                  <b>
                    {t('general:activities.assigned_asset_plural')}: {location.assets_count}
                  </b>
                </div>
                <div>
                  <b>
                    {t('general:activities.assigned_project_plural')}: {location.projects_count}
                  </b>
                </div>
              </React.Fragment>
            )}
            customResponse={(response: Object) => {
              return response.active;
            }}
            setItemDisabled={(item: Object) => {
              return item.assets_count > 0 || item.projects_count > 0;
            }}
          />
        </div>
        <ActionDrawerFormButtons
          form={form}
          submitTxt={t('general:actions.archive_location_plural')}
        />
      </React.Fragment>
    );
  }
}
